import { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import { withTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Container, Header, Icon, Segment } from 'semantic-ui-react';

// Import components
import ShowError from '../Components/Messages/ShowError';
import ShowSuccess from '../Components/Messages/ShowSuccess';
import { getTitlePrefix } from '../config/env';

import WSA from '../WSA';

class EmailSent extends Component {
  state = {
    error: '',
    icon: '',
    header: '',
    content: '',
    messageType: '',
  };

  renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {this.props.t('auth.emailConfirmation.browserTitle', {
          pageName: this.props.t('auth.emailConfirmation.pageTitle'),
        })}
      </title>
      <body className="email-sent" />
    </Helmet>
  );

  resendConfirmationEmail = async () => {
    try {
      const result = await WSA.Actions.sendVerificationEmail(this.props.authUser.uid);
      if (!result || result.errorCode) {
        throw new Error(this.props.t('auth.emailConfirmation.resendError'));
      }
      this.setState({
        content: this.props.t('auth.emailConfirmation.resendSuccess'),
        messageType: 'success',
      });
    } catch (error) {
      this.setState({
        verifying: false,
        content: error.message,
        messageType: 'error',
      });
    }
  };

  renderEmailResendAlert = () => {
    const { content, messageType } = this.state;

    if (!content || !messageType) return null;

    return <>{messageType === 'error' ? <ShowError content={content} /> : <ShowSuccess content={content} />}</>;
  };

  render() {
    const { t, authUser } = this.props;

    return (
      <Container style={{ width: 500 }}>
        {this.renderPageHead()}

        {this.renderEmailResendAlert()}

        <Segment textAlign="center" className="auth-wrapper">
          <Header>
            <Icon circular inverted name="mail" size="small" />
          </Header>

          <Header as="h1" content={t('auth.emailConfirmation.heading')} />

          <Segment basic>
            {t('auth.emailConfirmation.instructions')}: <strong>{authUser.email}</strong>
          </Segment>

          <Segment basic>
            {t('auth.emailConfirmation.resendPrompt')}{' '}
            <a
              href="#resent"
              onClick={(e) => {
                e.preventDefault();
                this.resendConfirmationEmail();
              }}
            >
              {t('auth.emailConfirmation.resendAction')}
            </a>
          </Segment>
        </Segment>
      </Container>
    );
  }
}
const mapAuthContextToProps = ({ authUser }) => {
  return {
    authUser,
  };
};

export default WSA.Components.mapAuthContextToProps(mapAuthContextToProps, withTranslation()(EmailSent));
